import { createContext, Dispatch, SetStateAction } from "react"

import adminStyles from "../styles/AdminView.module.css";
import buttonStyles from "../styles/Button.module.css";
import cardStyles from "../styles/Card.module.css";

export const AlertModalContext = createContext({
  setShowAlertModal: (_value: boolean) => {},
  setAlertMessage: (_value: string) => {}
});

type Props = {
    showModal : boolean,
    setShowModal : Dispatch<SetStateAction<boolean>>,
    text : string
    setText : Dispatch<SetStateAction<string>>
}

export function AlertModal({showModal, setShowModal, text, setText}: Props) {

    function close() {
        setShowModal(false);
        setText("");
    }

    return (<div> 
        {showModal &&
            <div className={adminStyles.modalOverlay} onClick={close}>
                <div
                  className={`${cardStyles.card} ${adminStyles.alertContent}`}
                  onClick={(e) => e.stopPropagation()}
                >
                    <h3>Alert</h3>
                    <div className={adminStyles.alertMessage}>
                        {text}
                    </div>
                    <button
                        className={`${buttonStyles.button} ${buttonStyles.primary}`}
                        onClick={close}
                    >
                        Close
                    </button>
                </div>
            </div>
        }
    </div>)
}
